import React from 'react';
import { Translate, I18n } from 'react-redux-i18n';
import SelectComponent from '../../select/Select';


class HeaderComponent extends React.PureComponent {
  state = {
    userType: null,
  }

  getBodySelect =
  values => (values.map(val => (<option key={val.value} value={val.value}>{val.name}</option>)));

  selectedItem = async (e) => {
    await this.props.setUserType(e);
  }

  selectedItemActive = async (e) => {
    await this.props.setUserActive(e);
  }

  render() {
    const {
      title, placeHolder, maxLength, onChange, onClickBtn1, titleBtn1, onClickBtn2, titleBtn2, id,
    } = this.props;
    const { userType } = this.state;
    return (
      <div>
        <h2 className="header-form-client">
          {title}
        </h2>

        {titleBtn1 && titleBtn1.length > 0
    && (
    <button
      onClick={onClickBtn1}
      type="button"
      className="btn btn-dark"
    >
      <Translate value="register" />
    </button>
    )
    }

        {titleBtn2 && titleBtn2.length > 0
    && (
    <button
      onClick={onClickBtn2}
      type="button"
      className="btn btn-secondary margin-left-10"
    >
      {titleBtn2}
    </button>
    )}
        {placeHolder && placeHolder.length
    && (
    <input
      className="float-right search-width-35p form-control"
      type="text"
      placeholder={placeHolder}
      maxLength={maxLength}
      onChange={onChange}
    />
    )}
        {id === 'users'
  && (
  <React.Fragment>
    <div className="d-flex flex-row-reverse margin-top-10">
      <SelectComponent
        title="Filtrar por tipo:"
        value={userType}
        body={this.getBodySelect([{ name: 'Admin', value: 'admin' },
          { name: I18n.t('user'), value: 'store' }])}
        onChange={e => this.selectedItem(e.target.value)}
      />
      <div className="margin-left-10" />
      <SelectComponent
        title="Filtrar por status:"
        value={userType}
        body={this.getBodySelect([{ name: 'Ativo', value: 'active' },
          { name: I18n.t('inactive'), value: 'inactive' }])}
        onChange={e => this.selectedItemActive(e.target.value)}
      />
    </div>

  </React.Fragment>
  )
  }
      </div>
    );
  }
}
export default HeaderComponent;
